import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { SharedServiceService } from 'app/services/shared-service.service';
declare var jQuery: any;
import { CardService } from 'app/components/cards/card.service';

@Component({
  selector: 'app-destination-cards',
  templateUrl: './destination-cards.component.html',
  styleUrls: ['./destination-cards.component.scss']
})
export class DestinationCardsComponent implements OnInit {
  cardList = [];
  allCardList = [];
  selectedCard = '';
  showCard = false;
  @Input() cardInfo = {
    bank: '',
    ownerNameFa: ''
  };
  @Input() hideList = false;
  @Input() hasError = false;
  @Input() invalid = false;
  @Input() title = 'شماره کارت مقصد';
  @Input() getCard;
  @Input() getPan;
  @Input() checkNovin = false;
  @Input() onlyNovin = false;
  errorNovin = false;
  loadingCards =  false;
  searchTitle = '';
  banksList = [];
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  constructor(private sharedService: SharedServiceService, private cardService: CardService) { }

  ngOnInit(): void {
    this.banksList = JSON.parse(localStorage.getItem('bankList'));
    this.allCardList = JSON.parse(sessionStorage.getItem('destinationCards'));
    if (this.allCardList === null) {
      this.getDestinationCard();
    } else {
      this.doStuff();
    }
  }
  sendParentNotification(i) {
    this.selectedCard = this.cardList[i].pan;
    const selectedCard = { ...this.cardList[i] };
    if (this.checkNovin) {
      this.checkIsNovin(this.selectedCard);
      if (!this.errorNovin) {
        this.notifyParent.emit(selectedCard);
      }
    } else {
      this.notifyParent.emit(selectedCard);
    }
    jQuery('#cards').modal('hide');
  }
  numberValidate(event) {
    this.sharedService.numberValidate(event);
  }
  creditPattern() {
    this.errorNovin = false;
    let temp = this.sharedService.convertToEnglishNumber(this.selectedCard);
    temp = temp.split('-').join('');
    if (this.checkNovin) {
      if (temp.length > 5) {
        this.checkIsNovin(temp);
      }
    }
    if (temp.length > 0) {
      temp = temp.match(new RegExp('.{1,4}', 'g')).join('-');
    }
    this.selectedCard = temp;
    if (this.selectedCard.length === 19) {
      this.cardInfo.bank = '';
      this.notifyParent.emit(this.selectedCard);
    }
    if (this.selectedCard.length === 0) {
      this.cardInfo.bank = '';
      this.notifyParent.emit(this.selectedCard);
    }
  }
  checkIsNovin(val) {
    val = val.split('-').join('');
    val = val.substr(0, 6);
    this.errorNovin = true;
    const novin = this.banksList.find(el => el.key === 'eghtesadnovin');
    novin.bins.forEach(element => {
      if (element === val) {
        this.errorNovin = false;
      }
    });
  }

  doStuff() {
    this.cardList = this.allCardList;
    if (this.getCard !== undefined && this.cardList.length > 0) {
      this.selectedCard = this.cardList.find(el => el.uniqueId === this.getCard.uniqueId).pan;
      document.getElementsByClassName('form-control')[0].classList.add('focused');
    }
    if (this.getPan !== undefined && this.cardList.length > 0) {
      this.getPan = this.getPan.match(new RegExp('.{1,4}', 'g')).join('-');
      this.selectedCard = this.cardList.find(el => el.pan === this.getPan).pan;
      document.getElementsByClassName('form-control')[0].classList.add('focused');
      this.notifyParent.emit(this.selectedCard);
    }
    if (this.onlyNovin === true) {
      this.cardList = this.cardList.filter(x => x.bank === 'eghtesadnovin');
    }
  }
  getDestinationCard() {
    this.loadingCards = true;
    this.cardService.getDestinationCards().subscribe(
        res => {
          this.loadingCards = false;
          if (res.code === 0) {
            this.allCardList = res.content;
            this.getDestinationCardDesign();
            sessionStorage.setItem('destinationCards', JSON.stringify(this.allCardList));
            this.doStuff();
          }
        }
      );
  }

  getDestinationCardDesign() {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.allCardList.length; i++) {
      const pan = this.allCardList[i].pan.substr(0, 7).split('-').join('');
      const result = this.cardService.getCardDesign(pan);
      if (result.nameFa !== '') {
        this.allCardList[i].gradient1 = result.gradient1;
        this.allCardList[i].gradient2 = result.gradient2;
        this.allCardList[i].textColor = result.textColor;
      }
    }
  }

  noSerachFilter() {
    if ( this.searchTitle.length === 1) {
      this.cardList = this.allCardList;
    }
  }
  searchEntity() {
    const results = [];
    if (this.searchTitle !== '') {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.allCardList.length; i++) {
        if (
          this.allCardList[i].title.includes(this.searchTitle.trim().toLowerCase())
          ||
          this.allCardList[i].pan.replace('-', '').includes(this.searchTitle.trim().toLowerCase())
        ) {
          results.push(this.allCardList[i]);
        }
      }
      this.cardList = results;
    }

  }
}
